import { Box } from '@apia/theme';
import { TLabel, objects } from '../../../../../objects/constants';
import { roles } from '../../../../../objects/costs/activities/structure';
import { hoursPerSquare } from './RolesHoursCount';

export function interpolateColor(
  minValue: number,
  maxValue: number,
  value: number,
  /**
   * Se utiliza para modificar la distribución de colores, de forma que sea más
   * representativa de las diferencias
   */
  exponent = 0.45,
) {
  const minColor: string = '#f5f5f5';
  const maxColor: string = '#4eaaff';

  function hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return {
      r: parseInt(result![1], 16),
      g: parseInt(result![2], 16),
      b: parseInt(result![3], 16),
    };
  }

  function rgbToHex(r: number, g: number, b: number) {
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  const minColorRgb = hexToRgb(minColor);
  const maxColorRgb = hexToRgb(maxColor);

  const percent = Math.pow(
    (value - minValue) / (maxValue - minValue),
    exponent,
  );

  if (isNaN(percent)) return minColor;

  const r = Math.round(
    minColorRgb.r + percent * (maxColorRgb.r - minColorRgb.r),
  );
  const g = Math.round(
    minColorRgb.g + percent * (maxColorRgb.g - minColorRgb.g),
  );
  const b = Math.round(
    minColorRgb.b + percent * (maxColorRgb.b - minColorRgb.b),
  );

  return rgbToHex(r, g, b);
}

export const RolesHoursCountTable = () => {
  const count = window.analysisTree.costs.schedule.useRolesHours();
  const length = count.rolesBlackBoxTester.length;

  let min = Infinity;
  let max = 0;

  Object.values(count).forEach((current) => {
    current.forEach((value) => {
      if (value < min) min = value;
      if (value > max) max = value;
    });
  });

  return (
    <Box as="table" className="proposal__diagram">
      <thead>
        <tr>
          <th>{objects.labels.week()}</th>
          {new Array<number>(length).fill(1).map((_, i) => (
            <th
              key={`${i * window.analysisTree.costs.schedule.daysPerSquare} - ${
                (i + 1) * window.analysisTree.costs.schedule.daysPerSquare
              }`}
            >
              {i + 1}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {roles.map((current) => (
          <tr key={current}>
            <th>{objects.labels[current as TLabel]()}</th>
            {new Array<number>(length).fill(1).map((_, i) => (
              <td
                style={{
                  backgroundColor: interpolateColor(
                    min,
                    max,
                    count[current][i],
                  ),
                }}
                key={`${
                  i * window.analysisTree.costs.schedule.daysPerSquare
                } - ${
                  (i + 1) * window.analysisTree.costs.schedule.daysPerSquare
                }`}
              >
                <Box>
                  {objects.labels.schedulePeopleCountMin(
                    (count[current][i] / hoursPerSquare).toFixed(2),
                  )}
                </Box>
                <Box>
                  {objects.labels.scheduleHoursCount(
                    count[current][i].toFixed(1),
                  )}
                </Box>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Box>
  );
};
